import React from 'react';
import Switch, { ReactSwitchProps } from 'react-switch';

type htmlInputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

type excludedHTMLInputProps =
  | 'onFocus'
  | 'onBlur'
  | 'onKeyUp'
  | 'onChange'
  | 'ref'
  | keyof ReactSwitchProps;

type allowedHTMLinputProps = Omit<htmlInputProps, excludedHTMLInputProps>;

const SwitchComponent: React.FC<ReactSwitchProps & allowedHTMLinputProps> = ({
  ...props
}) => {
  return (
    <Switch
      onColor="#4F46E5"
      offColor="#4B5563"
      checkedIcon={false}
      uncheckedIcon={false}
      height={20}
      width={40}
      {...props}
    />
  );
};

export default SwitchComponent;
